export default "__VITE_ASSET__8f85a0ef__"